/**
 * @fileoverview Partner Overview Page
 *
 * @author Chris Thomas (cthomas@yext.com)
 */

goog.module('yext.partneroverview');
goog.module.declareLegacyNamespace();

var partnerPath;

/**
 * @param {string} path the custom urlPath for the apps_partner's branded scan
 */
function init(path) {
  partnerPath = path;
  bindScanCountrySelector();
  // trigger initial form load
  $('#scan-country-selector').change();
}
goog.exportSymbol('yext.partneroverview.init', init);

/**
 * Binds country selector to refresh scan form
 */
function bindScanCountrySelector() {
  $('#scan-country-selector').change(function() {
    $.get(
      '/partner/' + partnerPath + '/scanInputTable',
      {psc: $(this).val()},
      function(data) {
        $('#scan-form').replaceWith(data);
        // open result in new tab
        $('#scan-form').attr('target', '_blank');
        $('#scan-submit').on('click', function() {
          $(this).closest('form').submit();
        });
      },
    );
  });
}

exports = {
  init,
  bindScanCountrySelector,
};
